import API_ENDPOINTS from '../config/apiConfig';
import { api } from './api';

const BASE = API_ENDPOINTS.JOURNAL_ADJUSTMENTS;

// List adjustments for a location + date range. Each row carries currentSourceAmount
// and needsReviewLive (the source value drifted from the baseline snapshot).
export const listJournalAdjustments = async ({ locationId, orgId, startDate, endDate } = {}) => {
  if (!locationId) throw new Error('locationId is required');
  const params = [`locationId=${locationId}`];
  if (orgId) params.push(`orgId=${orgId}`);
  if (startDate) params.push(`startDate=${startDate}`);
  if (endDate) params.push(`endDate=${endDate}`);
  const response = await api.get(`${BASE}?${params.join('&')}`);
  return response.data;
};

// Create a manual adjustment. Requires a note (reason) and a target (journalEntryTypeId
// or chartOfAccountId). The backend snapshots the underlying source value (baseline).
export const createJournalAdjustment = async (payload) => {
  const response = await api.post(BASE, payload);
  return response.data;
};

export const updateJournalAdjustment = async (id, payload) => {
  const response = await api.put(`${BASE}/${id}`, payload);
  return response.data;
};

export const deleteJournalAdjustment = async (id) => {
  const response = await api.delete(`${BASE}/${id}`);
  return response.data;
};

// Insert a contra (reversal) row + stamp the original.
export const reverseJournalAdjustment = async (id) => {
  const response = await api.post(`${BASE}/${id}/reverse`, {});
  return response.data;
};

// Re-baseline to the current source value and clear the needs-review flag.
export const acknowledgeJournalAdjustment = async (id) => {
  const response = await api.post(`${BASE}/${id}/acknowledge`, {});
  return response.data;
};
